<template>
  <div class="dictionary" :class="className" :title="word"><!--
  --><div class="dictionary__word" @click="onWordClick"><!--
    --><span>{{ word }}</span><!--
    --><SvgSymbol use="#info" class="dictionary__icon"/><!--
  --></div><!--
  --><transition name="popup-tween"><!--
    --><div class="dictionary__popup" ref="popup" :style="popupStyle" v-show="isPopupVisible">
        <button class="dictionary__close" title="關閉" @click.prevent="onCloseClick">關閉</button>
        <span class="dictionary__meaning" v-html="meaning"/>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Dictionary',
  props: {
    word: { type: String, required: true },
    meaning: { type: String, required: true }
  },
  data () {
    return {
      isPopupVisible: false,
      popupOffsetX: 0
    }
  },
  computed: {
    className () {
      return {
        'dictionary--visible': this.isPopupVisible
      }
    },
    popupStyle () {
      return {
        transform: `translateX(${this.popupOffsetX}px)`
      }
    }
  },
  methods: {
    onResize ({ width, height }) {
      this.calculatePopupOffset()
    },
    onDictionaryPopup (dictionary) {
      if (dictionary !== this) {
        this.isPopupVisible = false
      } else {
        this.isPopupVisible = true
        this.$scrollTo(this.$el, 500, { offset: -Math.floor(window.innerHeight * 0.3) })
      }
    },
    onWordClick () {
      this.calculatePopupOffset()
      this.isPopupVisible = true
      this.$bus.$emit('dictionary:popup', this)
      this.$ga('newmedia.send', {
        'hitType': 'event',
        'eventCategory': 'Read',
        'eventAction': 'Click',
        'eventLabel': 'Click_Word'
      })
    },
    onCloseClick () {
      this.isPopupVisible = false
    },
    calculatePopupOffset () {
      let viewWidth = window.innerWidth
      let paddingX = 10
      if (viewWidth >= 960) {
        paddingX = 50
      } else if (viewWidth >= 760) {
        paddingX = 50
      } else if (viewWidth >= 520) {
        paddingX = 35
      }
      let sideMenuWidth = 0
      if (viewWidth >= 760) {
        sideMenuWidth = 70
      }
      let popupWidth = 300
      if (window.innerWidth >= 520) {
        popupWidth += 35
      }
      let popupHalfWidth = popupWidth / 2
      let wordBounds = this.$el.getBoundingClientRect()
      let wordBegin = wordBounds.left
      let wordCenter = wordBounds.left + wordBounds.width / 2
      let minLeft = paddingX
      let maxRight = viewWidth - sideMenuWidth - paddingX - popupWidth
      let idealX = Math.floor(wordCenter - popupHalfWidth)
      if (idealX < minLeft) {
        idealX = minLeft
      } else if (idealX > maxRight) {
        idealX = maxRight
      }
      let offsetX = idealX - wordBegin
      this.popupOffsetX = offsetX
    }
  },
  beforeDestroy () {
    this.$bus.$off('resize', this.onResize)
    this.$bus.$off('dictionary:popup', this.onDictionaryPopup)
  },
  mounted () {
    this.$bus.$on('resize', this.onResize)
    this.$bus.$on('dictionary:popup', this.onDictionaryPopup)
  }
}
</script>

<style lang="scss">
.dictionary {
  $normal-color: #12a88e;
  $active-color: #da7561;
  $popup-border-color: #ebb1ab;
  $popup-close-color: #ebb1ab;
  z-index: 1;
  position: relative;
  color: $normal-color;
  display: inline-block;
  transition: color 0.3s;

  &__word {
    font-weight: bold;
    cursor: pointer;
  }

  &__icon {
    display: inline-block;
    width: 1em;
    height: 1em;
    margin-left: 0.05em;
    vertical-align: middle;
    margin-top: -0.275em;
  }

  &__popup {
    position: absolute;
    top: 100%;
    left: 0;
    width: 300px;
    min-height: 100px;
    padding: 28px 22px;
    font-size: 1rem;
    line-height: 1rem;
    letter-spacing: 0.1rem;
    background: white;
    border: 2px solid $popup-border-color;
    transition: transform 0.3s ease-out;
    box-shadow: 0 6px 8px -6px rgba(0, 0, 0, 0.4);
    @include rwd($RWD_TABLET_SMALL) {
      width: 335px;
    }
  }

  &__close {
    position: absolute;
    top: 0;
    right: 0;
    width: 24px;
    height: 24px;
    margin: -6px -6px 0 0;
    color: transparent;
    font-size: 0;
    background: $popup-close-color;
    border-radius: 50%;
    overflow: hidden;
    cursor: pointer;
    user-select: none;

    &:before,
    &:after {
      content: "";
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      width: 12px;
      height: 2px;
      margin: -1px 0 0 -6px;
      background: white;
      transform-origin: center center;
    }

    &:before {
      transform: rotate(45deg);
    }

    &:after {
      transform: rotate(-45deg);
    }

    &:active {
      transform: scale(0.9);
      transition: none;
    }
  }

  &__meaning {
    color: #1a1a1a;
    font-size: 0.875rem;
    font-weight: 600;
    line-height: 1.71em;
    letter-spacing: 0.1em;
  }

  &--visible {
    z-index: 2;
    color: $active-color;
  }

  .popup-tween {
    &-enter-active,
    &-leave-active {
      transition:
        opacity 0.3s,
        transform 0.3s;
    }
    &-enter {
      opacity: 0;
      transform: translate(-95%, -50%);
    }
    &-enter-to {
      opacity: 1;
      transform: translate(-100%, -50%);
    }
    &-leave {
      opacity: 1;
      transform: translate(-100%, -50%);
    }
    &-leave-to {
      opacity: 0;
      transform: translate(-100%, -50%);
    }
  }
}

.desktop {
  .dictionary {
    &__close {
      &:hover {
        transform: rotate(180deg);
        transition: transform 0.4s;
      }
    }
  }
}
</style>
